import {
  takeEvery, call, put, all
} from 'redux-saga/effects';
import * as actions from './actions';
import * as actionsUi from './actions_ui';

function* fetchData(action) {
  if (!action.api) {
    yield put({ type: action.cons.SUCCESS });
  }

  try {
    const data = yield call(action.api, action);
    yield put({ type: action.cons.SUCCESS, data });
  } catch (e) {
    console.error(e);
    yield put({
      type: action.cons.FAILURE,
      error: e,
      api: action.cons,
      timestamp: Date.now(),
    });
  }
}

function* updateLayout(action) {
  try {
    yield put({ ...action, type: action.cons.SUCCESS });
  } catch (e) {
    yield put({
      type: action.cons.FAILURE,
      error: e,
      api: action.cons,
      timestamp: Date.now()
    });
  }
}

function* allSagas() {
  const all_actions = [];
  for (let act in actions) {
    if (!actions[act]().cons) {
      continue;
    }
    all_actions.push(takeEvery(actions[act]().cons.FETCHING, fetchData));
  }
  for (let act in actionsUi) {
    all_actions.push(takeEvery(actionsUi[act]().cons.REQUEST_UPDATE, updateLayout));
  }
  yield all(all_actions);
}

export default allSagas;
